import { useTranslation } from 'react-i18next'

import { AmazonIcon } from 'app/common/presentation/icons'

import styles from './AuthorizationLogin.module.scss'

const AmazonLogin = () => {
  const { t } = useTranslation('connections')
  return (
    <div className={styles.amazon}>
      <div>
        <AmazonIcon />
        <span>{t('setup.authorization.amazon.signIn')}</span>
      </div>
    </div>
  )
}

export default AmazonLogin
